module.exports = __webpack_public_path__ + "img/refund.77cf459c.svg";